// "Jobs to do" is hosted once, in containers/App, beside "What's new". The top
// nav button, the PIP page (its Guide Intelligence "Invite" button) and the
// console command open it through this window event.
export const OPEN_ADMIN_JOBS_EVENT = 'tripadmit:open-admin-jobs';

// options: { guideId } opens straight at that guide's job.
export const openAdminJobs = (options = {}) =>
  window.dispatchEvent(new CustomEvent(OPEN_ADMIN_JOBS_EVENT, { detail: options }));

// How many jobs are waiting, for the top nav button. Kept here as well as
// broadcast: the top nav remounts on every page.
export const ADMIN_JOBS_COUNT_EVENT = 'tripadmit:admin-jobs-count';

let lastCount = 0;

export const getAdminJobsCount = () => lastCount;

export const publishAdminJobsCount = count => {
  lastCount = count || 0;
  window.dispatchEvent(new CustomEvent(ADMIN_JOBS_COUNT_EVENT, { detail: lastCount }));
};

// Jobs take priority over "What's new". While the jobs host is still asking
// whether there is anything to do ('pending') or has its dialog open
// ('open'), it says so on <body>; What's new reads the attribute before it
// opens and waits for the event to come back. Same shape as the guide tour
// picker's contract (components/TourSelectionGate), and read by name there
// for the same reason: neither feature has to import the other.
export const ADMIN_JOBS_ATTR = 'data-admin-jobs';
export const ADMIN_JOBS_EVENT = 'adminjobs:change';

export const markAdminJobs = state => {
  if (typeof document === 'undefined') return;
  if (state) document.body.setAttribute(ADMIN_JOBS_ATTR, state);
  else document.body.removeAttribute(ADMIN_JOBS_ATTR);
  window.dispatchEvent(new CustomEvent(ADMIN_JOBS_EVENT, { detail: { state: state || null } }));
};

export const isAdminJobsBlocking = () => {
  if (typeof document === 'undefined') return false;
  const state = document.body.getAttribute(ADMIN_JOBS_ATTR);
  return state === 'pending' || state === 'open';
};

// Only the company owner gets jobs: the decisions are theirs (who works for
// them, who gets an email).
export const isCompanyAdmin = user => user?.role === 'system_admin';
